// NotificationsContext.js
import React, { createContext, useState, useContext, useEffect } from 'react';

const NotificationsContext = createContext();

export const useNotifications = () => useContext(NotificationsContext);

export const NotificationsProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [notificationSoundEnabled, setNotificationSoundEnabled] = useState('Enabled');

  // Calculate unread count whenever notifications change
  const updateUnreadCount = (newNotifications) => {
    const count = newNotifications.filter(n => !n.isRead && !n.isArchived).length;
    setUnreadCount(count);
  };

  // Update notifications and recalculate unread count
  const updateNotifications = (newNotifications) => {
    setNotifications(newNotifications);
    updateUnreadCount(newNotifications);
  };

  // Add a single notification (e.g., from WebSocket)
  const addNotification = (newNotification) => {
    setNotifications((prev) => {
      const updatedNotifications = [newNotification, ...prev];
      updateUnreadCount(updatedNotifications);
      return updatedNotifications;
    });
  };

  return (
    <NotificationsContext.Provider
      value={{
        notifications,
        unreadCount,
        notificationSoundEnabled,
        setNotificationSoundEnabled,
        updateNotifications,
        addNotification,
      }}
    >
      {children}
    </NotificationsContext.Provider>
  );
};